
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/today-up/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/today-up/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/today-up/[[...pathParams]]"])
      });
    }
  